import React, { useEffect } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsSkipScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <div className="divtext_slov"><b>Вы можете пропустить заставку.</b></div>

            <button type="button" color="red"  onClick={() =>{props.sendMessage("sendtoserver|slov\\skip")}}>Пропустить</button><React.Fragment><br/></React.Fragment>
        </div>
    );
};